module.exports = __webpack_public_path__ + "media/images/pcidss-ac682af9129d5f07b37787ef1ad83ab1.png";